import { useNotifications } from './../../store/notifications/hooks'

export const useHeaderNotification = () => {
  const { notifications } = useNotifications()

  return {
    notifications,
  }
}
